// @mui material components
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { Box, Typography } from '@mui/material';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';

import image from '../../images/ordi_1.jpg';

const SectionWithBackground = () => {
    return (
        <Box
            display='flex'
            alignItems='center'
            borderRadius={3}
            my={2}
            py={6}
            sx={{
                backgroundImage: `linear-gradient(to right bottom, rgba(20, 116, 190, 0.8), rgba(126, 177, 200, 0.8)), url(${image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}
        >
            <Container>
                <Grid
                    container
                    item
                    xs={12}
                    lg={6}
                    sx={{ ml: { xs: 0, lg: 6 } }}
                >
                    <Typography variant='h6' color='white' fontWeight='bold'>
                        Curabitur laoreet metus
                    </Typography>
                    <Typography variant='h3' color='white' mb={1}>
                        Praesent Mattis
                    </Typography>
                    <Typography
                        variant='body1'
                        color='white'
                        opacity={0.8}
                        mb={2}
                    >
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Vestibulum vulputate, sem non condimentum vulputate,
                        elit felis mollis tellus, nec pharetra mauris quam non
                        velit. Maecenas massa felis, posuere vulputate ipsum
                        sed, ornare faucibus est.
                    </Typography>
                    <Typography
                        component='a'
                        href='https://mon-app.netlify.app/'
                        target='_blank'
                        rel='noreferrer'
                        variant='body2'
                        color='white'
                        fontWeight='regular'
                        sx={{
                            display: 'flex',
                            alignItems: 'center',

                            '& .MuiSvgIcon-root ': {
                                fontSize: '1.125rem',
                                transform: `translateX(3px)`,
                                transition:
                                    'transform 0.2s cubic-bezier(0.34, 1.61, 0.7, 1.3)',
                            },

                            '&:hover .MuiSvgIcon-root , &:focus .MuiSvgIcon-root ':
                                {
                                    transform: `translateX(6px)`,
                                },
                        }}
                    >
                        En savoir plus <TrendingFlatIcon fontWeight='bold' />
                    </Typography>
                </Grid>
            </Container>
        </Box>
    );
};

export default SectionWithBackground;
